// AwardsPage.jsx
import React, { useEffect, useState } from "react";
import "./AwardsPage.css";

// Import award images (replace with your real images)
import award1 from "../Assets/medals/awards1.jpg";
import award2 from "../Assets/medals/awards2.jpg";
import award3 from "../Assets/medals/awards3.jpg";
import award4 from "../Assets/medals/award4.jpg";
import award5 from "../Assets/medals/award5.jpg";
import award6 from "../Assets/medals/award6.jpg";
import award7 from "../Assets/medals/award7.jpg";
import award8 from "../Assets/medals/award8.jpg";


const AwardsPage = () => {
  const slides = [award1, award2, award3, award4, award5, award6, award7, award8];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 4000); // change slide every 4 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <section className="awards-page">

      {/* Title Section */}
      <div className="awards-header">
        <h1 className="awards-title">Our Awardees</h1>
        <p className="awards-subtitle">
          Celebrating excellence, impact, and dedication
        </p>
      </div>

      {/* Slideshow */}
      <div className="awards-slider">

        {slides.map((img, index) => (
          <div
            key={index}
            className={`slide ${index === currentIndex ? "active" : ""}`}
          >
            <img src={img} alt={`Awardee ${index + 1}`} />
          </div>
        ))}

      </div>

    </section>
  );
};

export default AwardsPage;